import { render, staticRenderFns } from "./agentStatementList.vue?vue&type=template&id=b9481fca&scoped=true"
import script from "./agentStatementList.vue?vue&type=script&lang=js"
export * from "./agentStatementList.vue?vue&type=script&lang=js"
import style0 from "./agentStatementList.vue?vue&type=style&index=0&id=b9481fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9481fca",
  null
  
)

export default component.exports